import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useDeviceType } from "../custom-hooks/useDeviceType";
import { DfpComponent } from "../ads/dfp-component";
import { HeroImage } from "../atoms/HeroImage";
import { PublishAndReadTime } from "../atoms/PublishAndReadTime";
import { HorizontalStory } from "./author-page/horizontal-stories/HorizontalStory";
import { TrendingStories } from "./section-page/trending-stories/TrendingStories";
import { Label } from "../atoms/Label";
import Headline from "../atoms/Headline";
import { getRecipeCookTime, getStoryHeadline, getStoryLabel, isExternalStory, storyTemplates } from "../utils/story";
import CookTime from "../atoms/CookTime";
import { getMenuGroups } from "../../../api/utils";

import "./tag.m.css";

const TagPage = (props) => {
  const [menuGroupsList, setMenuGroupsList] = useState([]);
  const deviceType = useDeviceType();
  const tagName = get(props, ["data", "tag", "name"], "");
  const isDesktop = deviceType === "desktop";
  const isMobile = deviceType === "mobile";
  const currPath = useSelector((state) => get(state, ["qt", "currentPath"], ""))
    .split("?")[0]
    .split("/")[1];
  const pageName = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_name_mapping", currPath], "sections")
  );
  const networkId = useSelector((state) => get(state, ["qt", "config", "ads-config", "network_id"], ""));
  const rightTopAdUnit = `/${networkId}/GULFNEWS/Gulfnews_ATF/gulfnews_${pageName}_atf/gulfnews_${pageName}_right_atf`;
  const rightBottomAdUnit = `/${networkId}/GULFNEWS/Gulfnews_BTF/gulfnews_${pageName}_btf/gulfnews_${pageName}_btf_right`;
  const BottomAdUnit = `/${networkId}/GULFNEWS/Gulfnews_BTF/gulfnews_${pageName}_btf/gulfnews_${pageName}_btf_footer`;

  const adConfig1 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_2"], {})
  );
  const adConfig2 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_2"], {})
  );
  const adConfig3 = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "section_page_adslot_3"], {})
  );
  const stories = props.data.stories.map(({ story }) => story) || [];
  const label = getStoryLabel(stories[0]);
  const [visibleItems, setVisibleItems] = useState(12);
  const imageUrl =
    get(stories[0], ["hero-image-s3-key"], "") ||
    get(stories[0], ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");

  const coverImage = get(props, ["data", "collection", "metadata", "cover-image"], null);

  const tagSlug = get(props, ["data", "tag", "slug"], "");
  const isSummerVibes = tagSlug === "summer-vibes";
  const isDiwali = tagSlug === "diwali";
  let tagData = {};
  if (isSummerVibes) {
    tagData = {
      title: "Summer Vibes",
      image: "https://images.assettype.com/gulfnews/2025-06-26/bf8ocr0v/Summer-vibes-badge-for-web.png",
      sponsortext: "In collaboration with Dubai Summer Surprises (DSS)",
      description:
        " Schools are closed, temperatures are soaring, but don’t sweat it — we’ve got you covered. We have the ultimate guide to the coolest things to do, see, eat and experience in the UAE during the holiday season, while staying safe and stylish.",
    };
  }
  if (isDiwali) {
    tagData = {
      title: "Diwali 2025",
      image: "https://images.assettype.com/gulfnews/2025-10-06/livvpup7/diwali.png",
      description:
        "The festival of lights is here, and the city is sparkling! Don't miss a single moment of the celebration — we’ve got you covered. Explore our ultimate Diwali guide for the best things to do, traditional recipes, gifting ideas, and the most dazzling decorations.",
    };
  }

  useEffect(async () => {
    setMenuGroupsList(await getMenuGroups());
  }, []);

  const sectionMenuList = menuGroupsList?.["menu-groups"]?.["main-nav"]?.items || [];

  const loadMoreStories = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 12);
  };

  const firstStoryheadline = getStoryHeadline(stories[0]);
  const externalStoryUrl = isExternalStory(stories[0]);
  const href = externalStoryUrl || `/${stories[0]?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  const isRecipe = stories[0] && stories[0]["story-template"] === storyTemplates.recipe;
  const cookTime = getRecipeCookTime(stories[0]);
  return (
    <div styleName="tag-page-container">
      <div className="container" styleName="wrapper">
        <div styleName="tag-container">
          {(isSummerVibes || isDiwali) && (
            <div styleName="tag-header-wrapper">
              <div styleName="tag-header">
                <div styleName="tag-content">
                  <div styleName="tag-image-wrapper">
                    <h3 styleName="tag-heading">{tagData?.title}</h3>
                    <div styleName="tag-image-mobile">
                      <img src={`${tagData.image}`} alt={tagName} />
                    </div>
                  </div>
                  {tagData?.sponsortext && <div styleName="sponsor-text">{tagData?.sponsortext}</div>}
                  <p styleName="tag-description">{tagData?.description}</p>
                </div>

                <div styleName="tag-image">
                  <img src={`${tagData.image}`} alt={tagName} />
                </div>
              </div>
            </div>
          )}
          {stories.length > 0 ? (
            <div styleName="firstStory">
              <Link href={href} target={target}>
                {label && (
                  <div styleName="label-container">
                    <Label story={stories[0]} />
                  </div>
                )}
                <div>{firstStoryheadline && <Headline headline={firstStoryheadline} />}</div>
              </Link>
              {stories[0]?.subheadline ? <h2>{stories[0].subheadline}</h2> : null}
              {!isRecipe ? (
                <PublishAndReadTime story={stories[0]} showReadTime={true} showTimestamp={true} />
              ) : (
                <CookTime cookTime={cookTime} />
              )}
              <Link href={href} target={target}>
                <HeroImage
                  story={stories[0]}
                  headline={stories[0].headline}
                  aspectRatio={[[4, 3]]}
                  iconSizes={{ height: 24, width: 24 }}
                  imageUrl={imageUrl}
                />
              </Link>
              <div styleName="row-separator"></div>
            </div>
          ) : (
            <div>
              <p styleName="no-article">We’re sorry, but no articles were found :(</p>
            </div>
          )}
          {stories.length > 0 && (
            <div styleName="articleList">
              {stories.slice(1, visibleItems).map((story) => (
                <HorizontalStory key={story.id} story={story} leftImage={true} />
              ))}
            </div>
          )}
          {visibleItems < stories.length && (
            <p styleName="loadmore-button" onClick={loadMoreStories}>
              LOAD MORE
            </p>
          )}
        </div>

        <div styleName="right-column">
          <div styleName="right-top-ad-slot">
            <DfpComponent
              adStyleName="ad-slot-size-300x600"
              id="tag-page-right-ad1"
              path={rightTopAdUnit}
              size={adConfig1.sizes}
              viewPortSizeMapping={adConfig1.view_port_size_mapping}
            />
          </div>
          <TrendingStories />
          {isDesktop && (
            <div styleName="right-bottom-ad-slot">
              <DfpComponent
                adStyleName="ad-slot-size-300x250-constant"
                id="tag-page-right-ad2"
                path={rightBottomAdUnit}
                size={adConfig2.sizes}
                viewPortSizeMapping={adConfig2.view_port_size_mapping}
              />
            </div>
          )}
        </div>
      </div>

      <div styleName="bottom-ad-container">
        <DfpComponent
          adStyleName={"ad-slot-size-970x250"}
          id="tag-page-bottom-ad"
          path={BottomAdUnit}
          size={adConfig3.sizes}
          viewPortSizeMapping={adConfig3.view_port_size_mapping}
        />
      </div>
    </div>
  );
};

export { TagPage };
TagPage.propTypes = {
  data: object,
};
